import React from 'react';

const UserSupport = () => {
    return (
        <div className="text-start p-3 rounded">
            <h5 className="mb-3">We Care About You!</h5>
            <p className="text-muted small">
                At Virtalibry, our customers are at the heart of everything we do. We are constantly working to enhance our
                services, introduce new features, and improve the overall experience to better serve you. Your feedback and
                satisfaction drive our innovation, and we are committed to making Virtalibry even better every day.
            </p>

            <p className="text-muted small">
                If you ever feel like something is missing or have an idea for a feature that could improve our platform,
                we've got you covered! We created a dedicated <strong>Wishlist</strong> section where you can share your
                ideas, track their progress, and see what’s coming next. Our team carefully reviews every suggestion, conducts
                brainstorming sessions, and evaluates the feasibility of implementation.
            </p>

            <p className="text-muted small">
                Your participation makes a real difference, and we truly appreciate you. No matter how unusual your request may be,
                our support team is always here to help. If you need assistance, feel free to reach out to us—we’ll do everything we can
                to resolve your issue quickly.
            </p>

            <p className="fst-italic text-muted small">
                Need help? Contact our support team at <a href="mailto:support@virtalibry.com">support@virtalibry.com</a>.
            </p>

            <p className="text-muted text-start small mt-4 fw-semibold">
                Thank you for being part of this journey. We love you! ❤️
            </p>
        </div>
    );
};

export default UserSupport;
